var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c("div", { staticClass: "page", attrs: { id: "group-list" } }, [
      _c(
        "div",
        { staticClass: "main-container", attrs: { id: "main-container" } },
        [
          _c(
            "van-pull-refresh",
            {
              on: { refresh: _vm.onRefresh },
              model: {
                value: _vm.ploading,
                callback: function($$v) {
                  _vm.ploading = $$v
                },
                expression: "ploading"
              }
            },
            [
              _c(
                "van-collapse",
                {
                  attrs: { accordion: "" },
                  model: {
                    value: _vm.activeName,
                    callback: function($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName"
                  }
                },
                [
                  _c(
                    "van-list",
                    {
                      attrs: {
                        finished: _vm.finished,
                        "finished-text": "没有更多了"
                      },
                      on: { load: _vm.onLoad },
                      model: {
                        value: _vm.loading,
                        callback: function($$v) {
                          _vm.loading = $$v
                        },
                        expression: "loading"
                      }
                    },
                    _vm._l(_vm.groupData, function(item) {
                      return _c(
                        "div",
                        { key: item.id, staticClass: "group-collapse-item" },
                        [
                          _c(
                            "van-collapse-item",
                            { attrs: { title: "有赞微商城", name: item.id } },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "title" }, slot: "title" },
                                [
                                  _c(
                                    "van-tag",
                                    { attrs: { color: "#EE2E50" } },
                                    [_vm._v(" " + _vm._s(item.groupName))]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(item.productGroupItemList, function(
                                gooditem
                              ) {
                                return _c("Goods", {
                                  key: gooditem.productId,
                                  staticStyle: { padding: "9px 12px" },
                                  attrs: { goodsData: gooditem }
                                })
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "item-footer" },
                                [
                                  _c("op-submit-bar", {
                                    attrs: {
                                      price: item.groupSellPrice,
                                      num: item.productGroupItemList.length,
                                      "button-text": "立即购买"
                                    },
                                    on: {
                                      submit: function($event) {
                                        _vm.onSubmit(item)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.activeName !== item.id
                            ? _c("div", { staticClass: "group-synopsis" }, [
                                _c(
                                  "div",
                                  { staticClass: "group-goods" },
                                  _vm._l(item.productGroupItemList, function(
                                    gooditem,
                                    i
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: gooditem.productId,
                                        staticClass: "group-goods-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "group-goods-img" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: gooditem.skuImage,
                                                alt: ""
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "group-goods-icon" },
                                          [
                                            i <
                                            item.productGroupItemList.length - 1
                                              ? _c("van-icon", {
                                                  attrs: { name: "plus" }
                                                })
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "group-footer" },
                                  [
                                    _c("op-submit-bar", {
                                      attrs: {
                                        price: item.groupSellPrice,
                                        num: item.productGroupItemList.length,
                                        btnShow: false,
                                        "button-text": "立即购买"
                                      },
                                      on: {
                                        submit: function($event) {
                                          _vm.onSubmit(item)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }